import { SvgIcon } from "@mui/material";
import { ReactComponent as VisibilityOffIcon } from "../icons/ic_visibility_off.svg";

function VisibilityOff(props) {
  return <SvgIcon {...props} component={VisibilityOffIcon} inheritViewBox />;
}

export default VisibilityOff;
